import { Component, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { Location } from '@angular/common';
import { DocumentTypeModel } from '../shared/model/DocumentType.model';
import { AnalystModel } from '../shared/model/Analyst.model';
import { BaseComponent } from '../base/base.component';
import { forkJoin } from 'rxjs';
import { ReviewRequestService } from '../services/review-request/review-request.service';
import { SubmittalTypeService } from '../services/submittal-type/submittal-type.service';
import { LookupService } from '../services/lookup/lookup.service';
import { DeterminationService } from '../services/determination/determination.service';
import { AnalystService } from '../services/analyst/analyst.service';
import { PublicationDateModel } from '../shared/model/publication-date.model';
import { SubmittalService } from '../services/submittal/submittal.service';
import { SubmittalModel } from '../shared/model/submittal.model';
import { AttachmentResponse } from '../shared/model/attachment-response.model';
import { AttachmentsService } from '../services/attachments/attachments.service';
import { DatePipe } from '@angular/common'
import { ActivatedRoute } from '@angular/router';
import { DeterminationModel } from '../shared/model/Determination.model';
import { ReviewRequestModel } from '../shared/model/ReviewRequest.model';

@Component({
  selector: 'app-submittal',
  templateUrl: './submittal.component.html',
  styleUrls: ['./submittal.component.css']
})
export class SubmittalComponent extends BaseComponent implements OnInit {
  form = this.fb.group({
    documentTypeName: [{value: null, disabled: true}],
    PublicationDate: [{ value: '', disabled: true }],
    CommentsDueDate: [{ value: '', disabled: true }],
    intake: new FormControl({ value: 'false', disabled: true }),
    publish: new FormControl({ value: false, disabled: true }),
    ActionDate: [{ value: '', disabled: true }],
    Determination: [{ value: '', disabled: true }],
    ReviewRequest: [{ value: '', disabled: true }, null],
    withdrawn: new FormControl({ value: false, disabled: true }),
    comment: [{value: null, disabled: true}, null],
    analyst: [{value: null, disabled: true}]
  });
  public tabIndex = new Array(true, false);
  SubmittalTypes: Array<DocumentTypeModel>;
  documentType: string;
  showPublicationDate = true;
  hideCommentDueDate = false;
  hideActionDate = false;
  analyst: AnalystModel;
  MepaAnalysts: Array<AnalystModel>;
  showDetermination = false;
  hideReviewRequest = false;
  submittalId: string;
  analystService: AnalystService;
  reviewRequests: any[];
  publicationDates: PublicationDateModel[];
  publicationDateElement: PublicationDateModel;
  determinations: any[];
  submittal = new SubmittalModel('', null, '', '', null, null, false, false, null, '', null, false, '', '', '', '');
  projectId: string;
  attachmentsModel: Array<AttachmentResponse> = [];
  userSetPublicationDate = true;
  publicationDate: Date;
  submittalVolumeIssue: String;
  reviewRequestButtons = new Array();
  determinationButtons = new Array();

  constructor(private fb: FormBuilder, private _location: Location, public _injector: Injector, private reviewRequestService: ReviewRequestService,
    private submittalTypeService: SubmittalTypeService, private lookupService: LookupService, private determinationService: DeterminationService,
    private submittalService: SubmittalService, private _attachmentService: AttachmentsService, public datePipe: DatePipe,
    private route: ActivatedRoute) {
    super(_injector);
    this.analystService = this._injector.get(AnalystService)
    if (this.route.snapshot.paramMap.has('id')) {
      this.submittalId = this.route.snapshot.paramMap.get('id');
    }

  }

  ngOnInit(): void {
    super.ngOnInit();

    const joinCalls = forkJoin([
      this.reviewRequestService.GetReviewRequests(),
      this.submittalTypeService.GetSubmittalTypes(),
      this.lookupService.GetPublicationDates(this.submittalId == undefined),
      this.determinationService.GetDeterminations(),
      this.analystService.GetAnalysts()]
    );

    joinCalls.subscribe((
      [reviewRequests, submittalTypes, publicationDates, determinations, analysts]) => {
      const emptySubmittalType = this.FillSubmittalTypeDropDown(reviewRequests);

      this.SubmittalTypes = emptySubmittalType.concat(submittalTypes);

      this.FillPublicationDateDropDown(publicationDates);

      this.FillDeterminationsDropdown(determinations);

      this.FillAnalystDropDown(analysts);

      if (this.submittalId != undefined) {
        this.submittalService.GetSubmittal(this.submittalId).subscribe(submittal => {
          this.submittal = submittal;
          
          this.submittal.eeaNo = this.submittalService.getEeaNumber();
          this.submittal.projectName = this.submittalService.getProjectName();

          this.projectId = submittal.projectId;
          this.attachmentsModel = submittal.attachments;
          this._attachmentService.publishAttachments(this.attachmentsModel);
          this.form.controls['documentTypeName'].setValue(this.submittal.documentTypeId, { emitEvent: true });
          this.userSetPublicationDate = false;
          this.form.controls['PublicationDate'].setValue(this.submittal.publicationId, { emitEvent: true });
          this.FindAndSetPublicationVolumeAndIssue();
          this.form.controls['CommentsDueDate'].setValue(this.submittal.commentsDueDate);
          this.form.controls['intake'].setValue(this.submittal.intake ? 'true' : 'false');
          this.form.controls['publish'].setValue(this.submittal.publish);
          this.showPublicationDate = this.submittal.publish;
          this.form.controls['ActionDate'].setValue(this.submittal.actionDate);
          this.form.controls['Determination'].setValue(this.submittal.determinationId);
          this.CreateDeterminationArray(this.submittal.determinationId);
          this.form.controls['ReviewRequest'].setValue(this.submittal.reviewRequestId);
          this.CreateReviewRequestArray(this.submittal.reviewRequestId);
          this.form.controls['withdrawn'].setValue(this.submittal.withdrawn);
          this.form.controls['comment'].setValue(this.submittal.comment);
          this.form.controls['analyst'].setValue(this.submittal.analystId);
          this.SelectedAnalyst(this.submittal.analystId);
          this.hideProgress();
        });
      }
    });

    this.onChanges();
  }

  CreateDeterminationArray(determinations: string[]) {
    determinations.forEach(determination => {
      let foundDetermination = this.determinations.find(determinationItem => determinationItem.id == determination);
      if(foundDetermination)
      {
        this.determinationButtons.push(foundDetermination.text);
      }
    })
  }

  CreateReviewRequestArray(reviewRequestIds: string[]) {
    reviewRequestIds.forEach(reviewRequestId => {
      let foundReviewRequest = this.reviewRequests.find(reviewRequest => reviewRequest.id == reviewRequestId);
      this.reviewRequestButtons.push(foundReviewRequest.text);
    });
  }

  onChanges() {
    this.form.get('documentTypeName').valueChanges.subscribe(val => {
      this.SelectedDocumentType();
    });

    this.form.get('PublicationDate').valueChanges.subscribe(val => {
      this.SelectedPublicationDate();
    });
  }

  SelectedPublicationDate() {
    const ctrlPublicationId = (<FormControl>this.form.controls['PublicationDate']);
    const ctrlDocumentTypeId = (<FormControl>this.form.controls['documentTypeName']);
    this.publicationDateElement = this.FindPublicationById(ctrlPublicationId.value);
    this.FindAndSetPublicationVolumeAndIssue();
    if (ctrlPublicationId.value !== '' && ctrlDocumentTypeId.value !== null) {
      var documentTypeFound = this.FindDocumentType(ctrlDocumentTypeId.value);
      this.HideCommentsDueDate(documentTypeFound);
      this.HideActionDate(documentTypeFound);
      if(this.userSetPublicationDate){
        this.GetCommentsDueDate(documentTypeFound, ctrlPublicationId.value);
        this.GetActionDate(documentTypeFound, ctrlPublicationId.value);
      }
    }
    this.userSetPublicationDate = true;
  }

  SelectedDocumentType() {
    const ctrlDocumentTypeId = (<FormControl>this.form.controls['documentTypeName']);
    const ctrlPublicationId = (<FormControl>this.form.controls['PublicationDate']);
    var documentTypeFound = this.FindDocumentType(ctrlDocumentTypeId.value);
    if (documentTypeFound != undefined) {
      this.documentType = documentTypeFound.documentTypeName;
      this.HideCommentsDueDate(documentTypeFound);
      this.HideActionDate(documentTypeFound);
      if (ctrlPublicationId.value !== '' && ctrlDocumentTypeId.value !== null) {
        this.GetCommentsDueDate(documentTypeFound, ctrlPublicationId.value);
        this.GetActionDate(documentTypeFound, ctrlPublicationId.value);
      }
      this.hideReviewRequest = documentTypeFound.hideReviewRequest;
      this.showDetermination = !documentTypeFound.intake;
      this.form.controls['intake'].setValue(documentTypeFound.intake == true ? 'true' : 'false');
      this.form.controls['publish'].setValue(documentTypeFound.publishDefault);
      this.showPublicationDate = documentTypeFound.publishDefault;
    }
  }
  GetActionDate(documentTypeFound: DocumentTypeModel, publicationId: any) {
    this.form.controls['ActionDate'].setValue('');
    if (documentTypeFound.actionDue !== null) {
      this.lookupService.GetDueDate(publicationId, documentTypeFound.actionDue).subscribe(dueDate => {
        if (dueDate !== null) {
          this.form.controls['ActionDate'].setValue(this.datePipe.transform(dueDate.dueDateValue, 'MM/dd/yyyy'), { emitEvent: false });
        }
      });
    }
  }

  GetCommentsDueDate(documentTypeFound: DocumentTypeModel, publicationId: any) {
    this.form.controls['CommentsDueDate'].setValue('');
    if (documentTypeFound.commentsDueDate !== null) {
      this.lookupService.GetDueDate(publicationId, documentTypeFound.commentsDueDate).subscribe(dueDate => {
        if (dueDate !== null) {
          this.form.controls['CommentsDueDate'].setValue(this.datePipe.transform(dueDate.dueDateValue, 'MM/dd/yyyy'), { emitEvent: false });
        }
      });
    }
  }
  
  HideActionDate(documentTypeFound: DocumentTypeModel) {
    this.hideActionDate = false;
    if (documentTypeFound.actionDue === '00000000-0000-0000-0000-000000000000') {
      this.hideActionDate = true;
    }
  }

  HideCommentsDueDate(documentTypeFound: DocumentTypeModel) {
    this.hideCommentDueDate = false;
    if (documentTypeFound.commentsDueDate === '00000000-0000-0000-0000-000000000000') {
      this.hideCommentDueDate = true;
    }
  }
  
  FindDocumentType(documentType: string): DocumentTypeModel {
    var documentTypes: DocumentTypeModel;
    if (this.SubmittalTypes !== undefined) {
      documentTypes = this.SubmittalTypes.find(x => x.documentTypeId == documentType);
    }
    return documentTypes;
  }

  FindAndSetPublicationVolumeAndIssue() {
    const ctrlPublicationId = (<FormControl>this.form.controls['PublicationDate']);
    var publicationFound = this.FindPublicationById(ctrlPublicationId.value);
    if (publicationFound) {
      this.publicationDate = new Date(publicationFound.publishDate);
      if (publicationFound !== undefined && publicationFound.volumeNumber !== null) {
        this.submittalVolumeIssue = 'Volume ' + publicationFound.volumeNumber.toString() + ', Issue ' + publicationFound.issueNumber.toString();
      } else {
        this.submittalVolumeIssue = '';
      }
    }
  }
  FindPublicationById(publicationId: any) {
    var publicationDateFound: PublicationDateModel;
    if (this.publicationDates !== undefined) {
      publicationDateFound = this.publicationDates.find(
        publication => publication.publicationId == publicationId
      )
    }
    return publicationDateFound;
  }

  FillAnalystDropDown(analysts: AnalystModel[]) {
    const selectItemNewElement = [new AnalystModel('', "Select", "One", null, null, null, null)];
    this.analyst = selectItemNewElement[0];
    this.MepaAnalysts = selectItemNewElement.concat(analysts);
  }

  FillDeterminationsDropdown(determinations: DeterminationModel[]) {
    if (determinations != null && determinations.length > 0) {
      this.determinations = determinations.map(a => ({ id: a.determinationId, text: a.determinationName }));
    }
  }

  FillPublicationDateDropDown(publicationDates: PublicationDateModel[]) {
    this.publicationDates = [new PublicationDateModel('', '', '-Not Selected-', null, null)];
    this.publicationDateElement = this.publicationDates[0];
    if (publicationDates != null && publicationDates.length > 0) {
      this.publicationDates = this.publicationDates.concat(publicationDates);
    }
  }
  FillSubmittalTypeDropDown(reviewRequests: ReviewRequestModel[]) {
    const emptySubmittalType = [new DocumentTypeModel(null, '-Not Selected-', '', null, false, false, false, false, '', '')];
    this.documentType = emptySubmittalType[0].documentTypeName;
    if (reviewRequests != null && reviewRequests.length > 0) {
      this.reviewRequests = reviewRequests.map(rr => ({ id: rr.reviewRequestId, text: rr.reviewRequestName }));
    }
    return emptySubmittalType;
  }

  onBackClick() {
    if (this.tabIndex[0] == true) {
      this._location.back();
    } else {
      this.tabIndex[0] = true;
      this.tabIndex[1] = false;
    }
  }

  onNextClick() {
    this.tabIndex[0] = false;
    this.tabIndex[1] = true;
  }

  get formControls(): any {
    return this.form['controls'];
  }

  SelectedAnalyst(selectedValue: string) {
    this.analyst = this.MepaAnalysts.find(sa => sa.analystId == selectedValue);
  }

  GoToProject() {
    if (this.submittal.projectId != null) {
      this.router.navigateByUrl(`/project/${this.submittal.projectId}`);
    }
  }
}
